import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function TypingSection() {
  const navigate = useNavigate();
  const roles = [
    "d'un accès à une base de candidats qualifiés",
    "d'une gestion simplifiée de vos commandes",
    "d'un suivi en temps réel de vos recrutements",
    "d'une facturation claire et transparente",
    "d'un accompagnement personnalisé tout au long du processus",
    "d'outils digitaux pour optimiser votre recrutement",
    "d'un support administratif réactif",
  ];

  const [currentRoleIndex, setCurrentRoleIndex] = useState(0);
  const [displayText, setDisplayText] = useState("");
  const [isDeleting, setIsDeleting] = useState(false);
  const [speed, setSpeed] = useState(100);

  useEffect(() => {
    const fullText = roles[currentRoleIndex];

    const handleTyping = () => {
      if (!isDeleting) {
        // Add one character
        setDisplayText(fullText.substring(0, displayText.length + 1));
        setSpeed(150);

        // When complete, start deleting after a pause
        if (displayText.length + 1 === fullText.length) {
          setTimeout(() => setIsDeleting(true), 1000);
        }
      } else {
        // Remove one character
        setDisplayText(fullText.substring(0, displayText.length - 1));
        setSpeed(50);

        // When fully deleted, move to next role
        if (displayText.length - 1 === 0) {
          setIsDeleting(false);
          setCurrentRoleIndex((prev) => (prev + 1) % roles.length);
        }
      }
    };

    const timer = setTimeout(handleTyping, speed);
    return () => clearTimeout(timer);
  }, [displayText, isDeleting, roles, currentRoleIndex, speed]);

  return (
    <section className="bg-white py-20">
      <div className="container mx-auto text-center">
        <h2 className="text-3xl font-bold text-gray-900">
          En tant que client, vous bénéficiez{" "}
          <span className="text-blue-600">
            {displayText}
            <span className="blinking-cursor">|</span>
          </span>
        </h2>
      </div>
      <style jsx="true">{`
        .blinking-cursor {
          display: inline-block;
          margin-left: 2px;
          width: 1px;
          background-color: currentColor;
          animation: blink 1s step-end infinite;
        }
        @keyframes blink {
          from,
          to {
            background-color: transparent;
          }
          50% {
            background-color: currentColor;
          }
        }
      `}</style>
    </section>
  );
}
